import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "South Dakota State Portal": {
    parameters: {
      linkUrls: ["https://apps.sd.gov/NR44TierII/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "SD",
  },
};
